export const makeRD = () => {
  return `_${Math.floor(Math.random() * 1000000000000)}`
}

/*
many-ans-mc,
one-ans-mc,
text-ans,
math-eq-ans,
range-val-ans,
open-end-ans
*/

export const removeMC = (arr, item, key) => {
  arr.splice(key, 1)
  return arr
}

export const addMC = (arr) => {
  const last = arr[arr.length - 1]
  const labelChar = last.label.toLowerCase().charCodeAt(0)
  const newLabel = String.fromCharCode(labelChar + 1)
  arr.push({
    label: newLabel.toUpperCase(),
    checked: false,
    isRight: false,
    latex: ''
  })
  return arr
}

export const getList = (answer) => {
  return answer.split('\n').filter(t => t !== '').map((line, i) => {
    return {
      int: i,
      line
    }
  })
}

export const markOpenEnd = (studentAns, teacherAns) => {
  return {
    mark: 1,
    markFull: 1,
    range: teacherAns,
    yourAnswer: studentAns,
    exampleAnswer: teacherAns.exampleAnswer
  }
}

export const markRangedValue = (studentAns, teacherAns) => {
  studentAns = Number(studentAns)
  const isWithinRange = studentAns <= teacherAns.max && studentAns >= teacherAns.min
  return {
    mark: isWithinRange ? 1 : 0,
    markFull: 1,
    range: teacherAns,
    correctAns: teacherAns.correctAns
  }
}

// var MathCompare = require('./MathCompare.js')
// export const markMathDoodle = (studentAns, teacherAns) => {
//   const listOfPossibleAnswer = getList(teacherAns)
//   const atLeastOneIsCorrect = listOfPossibleAnswer.filter(l => l.line.trim().toLowerCase() === studentAns.trim().toLowerCase()).length > 0
//   let mayBeOneCanMatch = listOfPossibleAnswer.map((possibleAns) => {
//     return MathCompare.compareIsEqual({
//       a: studentAns,
//       b: possibleAns.line,
//       onError: () => {}
//     })
//   })
//   let asLongAsOneIsCorrect = mayBeOneCanMatch.includes(true)
//   let eitherMatchStringOrMath = atLeastOneIsCorrect || asLongAsOneIsCorrect
//   return {
//     mark: eitherMatchStringOrMath ? 1 : 0,
//     markFull: 1,
//     correctAns: listOfPossibleAnswer
//   }
// }

// multiple answers

var MathCompare = require('./MathCompare.js')
export const markMathDoodle = (studentAns, teacherAns) => {
  const listOfPossibleAnswer = getList(teacherAns)
  const filterOutDFrag = (str) => {
    // eslint-disable-next-line no-useless-escape
    str = str.replace(new RegExp(`dfrac`), 'frac')
    return str
  }
  const stringCOmpare = listOfPossibleAnswer.filter(l => filterOutDFrag(l.line.trim().toLowerCase()) === filterOutDFrag(studentAns.trim().toLowerCase())).length > 0
  let mayBeOneCanMatch = listOfPossibleAnswer.map((possibleAns) => {
    return MathCompare.compareIsEqual({
      a: filterOutDFrag(studentAns),
      b: filterOutDFrag(possibleAns.line),
      onError: () => {}
    })
  }).includes(true)

  return {
    mark: (stringCOmpare || mayBeOneCanMatch) ? 1 : 0,
    markFull: 1,
    correctAns: listOfPossibleAnswer
  }
}

// export const markMathDoodle = (studentAns, teacherAns) => {
//   const listOfPossibleAnswer = [{ line: teacherAns }]
//   const atLeastOneIsCorrect = listOfPossibleAnswer.filter(l => l.line.trim().toLowerCase() === studentAns.trim().toLowerCase()).length > 0
//   return {
//     mark: atLeastOneIsCorrect ? 1 : 0,
//     markFull: 1,
//     correctAns: listOfPossibleAnswer
//   }
// }
export const markText = (studentAns, teacherAns) => {
  const listOfPossibleAnswer = getList(teacherAns)
  const atLeastOneIsCorrect = listOfPossibleAnswer.filter(l => l.line.trim().toLowerCase() === studentAns.trim().toLowerCase()).length > 0
  return {
    mark: atLeastOneIsCorrect ? 1 : 0,
    markFull: 1,
    correctAns: listOfPossibleAnswer
  }
}

export const markMAMC = (studentAns, teacherAns) => {
  const merged = studentAns.map(sAns => {
    const tans = teacherAns.find(t => t.label === sAns.label) || {}
    return {
      ...tans,
      ...sAns
    }
  })

  const stats = merged.reduce((info, mc) => {
    if (mc.isRight && mc.checked) {
      info.markIncDec = info.markIncDec + 1
      info.mark = info.mark + 1
      info.correct.push(mc.label)
    } else if (!mc.isRight && mc.checked) {
      info.markIncDec = info.markIncDec - 1
      info.incorrect.push(mc.label)
    }
    return info
  }, {
    markIncDec: 0,
    mark: 0,
    markFull: merged.reduce((cc, i) => {
      if (i.isRight) {
        cc++
      }
      return cc
    }, 0),
    correct: [],
    incorrect: []
  })

  return {
    ...stats,
    correctAns: merged.filter(tt => tt.isRight).map(tt => tt.label),
    response: merged
  }
}

export const markSAMC = (studentAns, teacherAns) => {
  const merged = studentAns.map(sAns => {
    const tans = teacherAns.find(t => t.label === sAns.label) || {}
    return {
      ...tans,
      ...sAns
    }
  })

  const stats = merged.reduce((info, mc, i) => {
    if (mc.isRight && mc.checked) {
      info.mark = 1
      info.markIncDec = 1
    } else if (!mc.isRight && mc.checked) {
      info.hasWrong = true
    }

    if (i === (merged.length - 1)) {
      if (info.hasWrong) {
        info.mark = 0
        info.markIncDec = -1
      }
    }
    return info
  }, {
    hasWrong: false,
    mark: 0,
    markIncDec: 0,
    markFull: 1,
    correctAns: (merged.find(m => m.isRight) || { label: 'unknown' }).label
  })

  return {
    ...stats,
    response: merged
  }
}

export const getKeyName = (question) => {
  return (getAPIs(question) || { keyname: 'unknown' }).keyname
}

export const getAPIs = (question) => {
  return (ansTypes.find(an => an.type === question.ansType)) || false
}

export const ansTypes = [
  {
    style: { backgroundColor: '#0000ff', color: '#ffffff', border: '#ffffff solid 1px' },
    name: 'Multiple Answer MC',
    type: 'many-ans-mc',
    keyname: 'maMC',
    getTemplate() {
      return [
        {
          label: 'A',
          isRight: true,
          latex: ''
        },
        {
          label: 'B',
          isRight: true,
          latex: ''
        },
        {
          label: 'C',
          isRight: false,
          latex: ''
        },
        {
          label: 'D',
          isRight: false,
          latex: ''
        }
      ]
    },
    filterOutAns(ans) {
      return ans.map((aa) => {
        const qs = { ...aa }
        delete qs.isRight
        qs.checked = false
        return qs
      })
    }
  },
  {
    style: { backgroundColor: '#FF1D25', color: '#ffffff', border: '#ffffff solid 1px' },
    name: 'Single Answer MC',
    type: 'one-ans-mc',
    keyname: 'saMC',
    getTemplate() {
      return [
        {
          label: 'A',
          isRight: true,
          latex: ''
        },
        {
          label: 'B',
          isRight: false,
          latex: ''
        },
        {
          label: 'C',
          isRight: false,
          latex: ''
        },
        {
          label: 'D',
          isRight: false,
          latex: ''
        }
      ]
    },
    filterOutAns(ans) {
      return ans.map((aa) => {
        const qs = { ...aa }
        delete qs.isRight
        qs.checked = false
        return qs
      })
    }
  },
  {
    style: { backgroundColor: '#00FF00', color: '#000000', border: '#ffffff solid 1px' },
    name: 'Text Answer',
    type: 'text-ans',
    keyname: 'text',
    getTemplate() {
      return {
        hint: '',
        correctAns: '',
        ans: ''
      }
    },
    filterOutAns(ans) {
      const qs = { ...ans }
      delete qs.correctAns
      return qs
    }
  },
  {
    style: { backgroundColor: '#FCEE21', color: '#000000', border: '#ffffff solid 1px' },
    name: 'Math Equation Doodle',
    type: 'math-eq-ans',
    keyname: 'math',
    getTemplate() {
      return {
        hint: '',
        correctAns: '',
        ans: ''
      }
    },
    filterOutAns(ans) {
      const qs = { ...ans }
      delete qs.correctAns
      return qs
    }
  },
  {
    style: { backgroundColor: '#F15A24', color: '#ffffff', border: '#ffffff solid 1px' },
    name: 'Ranged Value Answer',
    type: 'range-val-ans',
    keyname: 'range',
    getTemplate() {
      return {
        hint: '',
        correctAns: 0,
        min: 0,
        max: 100,
        ans: 0
      }
    },
    filterOutAns(ans) {
      const qs = { ...ans }
      delete qs.correctAns
      return qs
    }
  },
  {
    style: { backgroundColor: '#7c3bfb', color: '#ffffff', border: '#ffffff solid 1px' },
    name: 'Open Ended Question / Survey',
    type: 'open-end-ans',
    keyname: 'open',
    getTemplate() {
      return {
        hint: '',
        exampleAnswer: '',
        ans: ''
      }
    },
    filterOutAns(ans) {
      const qs = { ...ans }
      delete qs.exampleAnswer
      return qs
    }
  }
]

export const injectAnsDataByType = (question, type) => {
  const api = ansTypes.find(t => t.type === type)
  question.ansType = type
  const ans = api.getTemplate()
  question.ansData = {
    [api.keyname]: ans
  }
  return question
}

export const attachQuestionOnlyData = (question) => {
  const type = question.ansType
  if (type === 'unknown') {
    return question
  }
  const api = ansTypes.find(t => t.type === type)
  const ans = question.ansData[api.keyname]
  question.cleanData = {
    [api.keyname]: api.filterOutAns(ans)
  }
  return question
}

export const makeSampleQuestion = () => {
  return {
    _id: makeRD(),

    // Question
    latex: ``,

    // Answer Type
    ansType: `unknown`,
    ansData: false,
    cleanData: false
  }
}
